import {Locales} from '@netx/core-next/locales/utils/Locales';
import {MetadataType} from './constants';

export const MetadataTypeLabel: Record<MetadataType, string> = Locales(
	(i18n) => ({
		[MetadataType.EXCLUDE]: i18n('i18n.matchExclude'),
		[MetadataType.MATCH_ALL_WHOLE_WORDS]: i18n('i18n.matchAllWholeWordsAND'),
		[MetadataType.MATCH_ALL_WILD_CARDS]: i18n('i18n.matchAllFragments'),
		[MetadataType.MATCH_ANY_RANGE]: i18n('i18n.matchAnyRange'),
		[MetadataType.MATCH_ANY_WHOLE_WORDS]: i18n('i18n.matchAnyWholeWordsOR'),
		[MetadataType.MATCH_ANY_WILD_CARDS]: i18n('i18n.matchAnyFragment'),
		[MetadataType.MATCH_EXACTLY]: i18n('i18n.matchExactly'),
		[MetadataType.MATCH_VALUE_IS_EMPTY]: i18n('i18n.matchValueIsEmpty'),
		[MetadataType.MATCH_VALUE_IS_NOT_EMPTY]: i18n('i18n.matchValueIsNotEmpty'),
	}),
);
